import React, { useState } from "react"

import parse from "html-react-parser"

import SectionsTitle from "../../../Common/new/SectionsTitle"

import { replaceUnderscoresWithSpaces } from "../../../utils/functions"

import ArrowDown from "../../svg/new/arrowDown"
import * as style from "./healthCareWhatWeDo.module.css"
import BankIcon from "../../svg/new/bank"

const HealthCareWhatWeDo = props => {
  const {
    serviceTitle,
    serviceTag,
    serviceShowSection,
    serviceShortDescription,
    serviceImageContentList,
    isCollapse,
  } = props

  const [activeIndex, setActiveIndex] = useState(0)

  const handleActiveIndex = index => {
    setActiveIndex(prev => (prev === index ? null : index))
  }

  return (
    <>
      {serviceShowSection === "yes" && (
        <section className={``}>
          <div className="container">
            <div className={style.healthcare_wrap}>
              <div className={style.healthcare_left}>
                <SectionsTitle
                  title={replaceUnderscoresWithSpaces(serviceTag)}
                  SubTitle={serviceTitle}
                  Content={serviceShortDescription}
                  styleCss={{ display: "none" }}
                  classnames={style.section_class}
                />
              </div>
              <div className={style.healthcare_right}>
                {Array.isArray(serviceImageContentList) &&
                  serviceImageContentList?.map((item, index) => {
                    const isActive = activeIndex === index
                    return (
                      <div
                        className={`${style.serve_wrap} ${
                          isActive ? style.active : ""
                        }`}
                        key={index}
                      >
                        <div 
                        className={`${style.card_title} ${isCollapse==="yes" && style.card_title_hover}`} 
                        onClick={
                          isCollapse === "yes"
                            ? () => handleActiveIndex(index)
                            : undefined
                        }
                        >
                          <div className={style.heading}>
                            <i>
                              {item.serviceListImage ? (
                                parse(`${item.serviceListImage}`)
                              ) : (
                                <BankIcon />
                              )}
                            </i>
                            <h3>{item?.serviceListTitle}</h3>
                          </div>
                          {isCollapse === "yes" && (
                            <span className={`${style.arrow}`}>
                              <i>
                                <ArrowDown />
                              </i>
                            </span>
                          )}
                        </div>
                        <p
                          className={
                            isCollapse === "yes"
                              ? style.card_desc
                              : style.card_desc_coll
                          }
                        >
                          {parse(`${item?.serviceListContent}`)}
                        </p>
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default HealthCareWhatWeDo
